// ** Third Party Components
import styled, { css } from "styled-components";

export const StyledSvgIconContainer = styled.span`
	svg {
		fill: ${({ theme: { colors } }) => colors.grey};
		display: inline-block;
		vertical-align: text-top;

		${({ $customVerticalAlign }) =>
			$customVerticalAlign &&
			css`
				vertical-align: ${$customVerticalAlign};
			`};

		height: 1em;

		${({ $customHeight }) =>
			$customHeight &&
			css`
				height: ${$customHeight};
			`};

		${({ $customMargin }) =>
			$customMargin &&
			css`
				margin: ${$customMargin};
			`};

		${({ $customFill }) =>
			$customFill &&
			css`
				fill: ${({ theme: { colors } }) => colors[$customFill]};
			`};
	}
`;
const DynamicLockIcon = ({
	privateData = false,
	customHeight,
	customMargin,
	customFill,
	customVerticalAlign,
}) => {
	return (
		<StyledSvgIconContainer
			$customHeight={customHeight}
			$customMargin={customMargin}
			$customFill={customFill}
			$customVerticalAlign={customVerticalAlign}
		>
			{privateData ? (
				<svg
					aria-hidden="true"
					focusable="false"
					data-prefix="fas"
					data-icon="lock"
					className="svg-inline--fa fa-lock fa-w-14"
					role="img"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 448 512"
				>
					{/* SVG w tym komponencie jest od nas z plików i nie miał zapisu o licencji. */}
					<path d="M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"></path>
				</svg>
			) : (
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
					{/*<!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->*/}
					<path d="M144 144c0-44.2 35.8-80 80-80c31.9 0 59.4 18.6 72.3 45.7c7.6 16 26.7 22.8 42.6 15.2s22.8-26.7 15.2-42.6C331 33.7 281.5 0 224 0C144.5 0 80 64.5 80 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H144V144z" />
				</svg>
			)}
		</StyledSvgIconContainer>
	);
};

export default DynamicLockIcon;
